import ChangeSupport from './ChangeSupport';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'changeSupport' ],
  changeSupport: [ 'type', ChangeSupport ]
};